import React, { FC } from 'react';
import classNames from 'classnames';
import ContainerWithShadow from 'components/common/ContainerWithShadow';
import styles from 'components/common/calendar/index.module.scss';
import { useHistory } from 'react-router-dom';
import MobileService from 'services/mobile';
import Table from './table';
import componentStyles from './index.module.scss';
import buttons from '../../style/buttons.module.scss';

const TimeTable: FC = () => {
  const history = useHistory();

  return (
    <main
      className={`${classNames(styles.container)} ${
        componentStyles.container
      } ${MobileService.isMobile ? styles.tablet : ''}`}
    >
      <ContainerWithShadow
        className={`${classNames(styles.container)} ${
          MobileService.isMobile ? styles.tablet : ''
        }`}
      >
        <Table />
      </ContainerWithShadow>
      <div
        className={`${componentStyles.buttons} ${
          MobileService.isMobile ? componentStyles.tablet : ''
        }`}
      >
        <button
          type="submit"
          className={buttons.buttomPrimary}
          onClick={() => history.push('/map')}
        >
          Back to map
        </button>
      </div>
    </main>
  );
};

export default TimeTable;
